export default "__VITE_ASSET__BX237fmk__"